module.exports = __webpack_public_path__ + "static/media/mh.40dbb5c2.svg";